import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Gallery.css"; // External CSS for styling
import img1 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.27_40fc0d9c.jpg';
import img2 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.28_1072507e.jpg';
import img3 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.28_fdcc558c.jpg';
import img4 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.30_d5f79eb3.jpg';
import img5 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.30_d8bf18be.jpg';
import img6 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 20.15.16_e66389b0.jpg';
import img7 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 20.00.38_e154a793.jpg';
import img8 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 19.58.30_2d58d63a.jpg';

const images = [
  img1,img2,img3,img4,img5,img6,img7,img8
];

const Gallery = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };
  
    return (
      <div className="gallery-container">
        <h1>Holi Milan 2025</h1>
        <Slider {...settings}>
          {images.map((src, index) => (
            <div key={index} className="gallery-item">
              <img src={src} alt={`Gallery ${index + 1}`} className="gallery-img" />
            </div>
          ))}
        </Slider>
      </div>
    );
  };
  
  export default Gallery;
  